import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import classNames from 'classnames';
import { Tooltip } from '@mui/material';
import { useIntl } from 'react-intl';
import ResourceRequestRoleTooltip from './ResourceRequestRoleTooltip';

const useStyles = makeStyles(theme => ({
  container: {
    display: 'flex',
    minWidth: 0,
    ...theme.typography.body2
  },
  roleName: {
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    margin: theme.spacing(0, 0.5, 0, 0)
  },
  roleCount: {
    flexShrink: 0
  },
  noRole: {
    color: theme.palette.text.secondary
  },
  root: {}
}));

export const ResourceRequestRoleCount2 = ({
  role,
  roleCount,
  classes: classesOverride
}) => {
  const classes = useStyles({ classes: classesOverride });
  const intl = useIntl();

  const displayRoleText =
    role?.displayText ||
    intl.formatMessage({
      id: `resourceRequestReadonlyItem.noRole`
    });

  const title = useMemo(
    () => <ResourceRequestRoleTooltip role={role} roleCount={roleCount} />,
    [role, roleCount]
  );

  return (
    <div
      className={classNames(classes.container, {
        [classes.noRole]: !role?.displayText
      })}
    >
      <Tooltip title={title} placement="bottom-start">
        <span tabIndex={0} className={classes.root} role="button">
          <span className={classes.roleName}>{displayRoleText} </span>
          <span className={classes.roleCount}>x {roleCount}</span>
        </span>
      </Tooltip>
    </div>
  );
};

ResourceRequestRoleCount2.propTypes = {
  role: PropTypes.object,
  roleCount: PropTypes.number.isRequired,
  classes: PropTypes.object
};

export default ResourceRequestRoleCount2;
